/* eslint-disable react/jsx-key */
/* eslint-disable no-unused-expressions */
/* eslint-disable no-alert */
/* eslint-disable no-nested-ternary */

import * as React from "react";

import Grid from "@mui/material/Grid";
// Data
// Dashboard components
import Card from "@mui/material/Card";
import Box from "@mui/material/Box";
// Material Dashboard 2 React components
// Authentication layout components
import { useTranslation } from "react-i18next";
import { CircularProgress } from "@mui/material";
import axios from "axios";
import SysDashLayout from "../../components_reefer/Layouts/SysDashLayout";
import config from "../../config/config.json";
// I18N
import MDTypography from "../../components/MDTypography";
import OrdersOverview from "./components/OrdersOverview";
import Projects from "./Projects/index";
import DockCard from "../../components_reefer/Cards/StatisticsCards/DockCard/index";
import MDBox from "../../components/MDBox";
import authHeader from "../../helpers/auth-headers";
import authService from "../../helpers/auth.service";

export default function Dashboard() {
  const { t } = useTranslation("common");
  // const [patio, setPatio] = React.useState("");
  const [patioList, setPatioList] = React.useState([]);
  const [fetched, setFetched] = React.useState(false);
  const [loading, setLoading] = React.useState(true);
  const { API_URL } = config;
  const user = authService.getCurrentUser();

  // Uma única chamada alimenta cards, totais e tabela. O backend já omite pátios
  // com showOnDashboard = 0; aqui só tiramos os inativos.
  React.useEffect(() => {
    axios
      .get(`${API_URL}dashboard/${user.accountsIdaccounts}`, { headers: authHeader() })
      .then(
        (response) => {
          setPatioList(
            response.data.flatMap((porto) => porto.patios).filter((p) => p.isActive === 1)
          );
        },
        (error) => {
          console.log(error);
        }
      )
      .finally(() => {
        setLoading(false);
        setFetched(true);
      });
  }, []);

  return (
    <SysDashLayout>
      <Card p={1}>
        <MDBox
          variant="gradient"
          bgColor="info"
          borderRadius="lg"
          coloredShadow="info"
          mx={2}
          mt={-2}
          p={2}
          mb={1}
          textAlign="center"
        >
          <MDTypography variant="h4" fontWeight="medium" color="white" mt={1}>
            {t("menu.dash")}
          </MDTypography>
        </MDBox>
        {fetched && patioList.length === 0 ? (
          <MDTypography variant="button" color="text" textAlign="center" mt={6}>
            {t("dashboard.dash_empty")}
          </MDTypography>
        ) : null}
        {loading ? (
          <Box sx={{ width: "100%" }} ml="48%" mt={10}>
            <CircularProgress color="info" />
          </Box>
        ) : null}
        <MDBox pt={6} pb={3} px={3}>
          <Grid container spacing={4} px={6} justifyContent="center">
            {patioList.map((p) => (
              <Grid item xs={12} md={6} lg={4} key={p.idpatios}>
                <DockCard
                  title={p.name}
                  count={`${p.containersComplete.length} ${t("dashboard.dash_conts")}`}
                  Monit={`${p.containersMonitored.length} ${t("dashboard.dash_monits")}`}
                  Err={`${p.monitErr} ${t("dashboard.dash_errs")}`}
                />
              </Grid>
            ))}
          </Grid>
          <MDBox>
            <Grid container spacing={3}>
              <Grid item xs={12} md={6} lg={6} mt={6}>
                <Projects patios={patioList} />
              </Grid>
              <Grid item xs={12} md={6} lg={6} mt={6}>
                <OrdersOverview patios={patioList} />
              </Grid>
            </Grid>
          </MDBox>
        </MDBox>
      </Card>
    </SysDashLayout>
  );
}
